/* eslint-disable no-useless-escape */
<template>
  <div class="detail">
    <div class="layer">
      <!-- 专家信息部分 -->
      <el-row class="d-t">
        <el-col :span="18" class="d-t-br">
          <div class="d-t-l-t" style="height: 300px">
            <el-row :gutter="30" v-loading="loading1" class="d-t-l-h">
              <el-col :span="4">
                <div class="d-t-header">
                  <img
                    v-if="nameOrgArray.avatarUrl"
                    :src="
                      avatarUrl || '/old/public' + nameOrgArray.avatarUrl
                    "
                    @error="errImg"
                  />
                  <img
                    v-else
                    class="exp-header"
                    src="http://expert.ckcest.cn/autoload/images/avatar.png"
                  />
                </div>
              </el-col>

              <el-col :span="8" class="detail">
                <h3 style="color: #879b86">
                  {{ nameOrgArray.name }} {{ nameOrgArray.positionalTitle }}
                  <el-button
                    v-if="false && isPath "
                    @click="talent()"
                    type="primary"
                    size="small"
                    style="margin-left: 20px"
                  >专家路径</el-button>
                  <el-button
                    v-if="acadUrl"
                    @click="goAcad()"
                    type="primary"
                    size="small"
                    style="margin-left: 20px"
                  >更多</el-button>
                  <el-button
                    style="margin-left: 20px"
                    v-if="!/^\d+$/.test(nameOrgArray.kId)"
                    @click="claim()"
                    type="primary"
                    size="small"
                    :class="{ disabled: /^\d+$/.test(nameOrgArray.kId) }"
                  >认领</el-button>
                  <span v-else style="margin-left: 20px">
                    <i
                      class="el-icon-circle-check"
                    >{{ (nameOrgArray.claimType == 0?'机器认领':(nameOrgArray.claimType == 1?'本人认领':'人工认领'))}}</i>
                  </span>
                </h3>
                <div v-if="nameOrgArray.organization" class="txovh">
                  <div
                    :title="nameOrgArray.organization"
                    v-for="(item, index) in nameOrgArray.organization
                      .split(';')
                      .slice(0, 5)"
                    :key="index"
                  >
                    <span v-if="!index">机构</span>
                    <span v-else>&ensp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="color: #879b86; margin-left: 10px">
                      {{
                      item
                      }}
                    </span>
                    <!-- <span @mouseover="hover($event,item)"
                    @mouseleave="leave">{{item}}</span>-->
                  </div>
                </div>

                <a
                  v-if="nameOrgArray.isni"
                  :href="'http://www.isni.org/' + nameOrgArray.isni"
                  target="_blank"
                >
                  ISNI：{{
                  nameOrgArray.isni
                  .replace(/(.{4})/g, "$1-")
                  .slice(0, nameOrgArray.isni.length + 3)
                  }}
                </a>

                <div v-if="nameOrgArray.subject" class="txovh6">
                  <div>
                    <span>
                      学科
                      <m-tips title="学科" content="学科来自学者中文发文的TOP 5学科归属。"></m-tips>
                    </span>
                  </div>
                  <div
                    v-for="(item, index) in nameOrgArray.subject
                      .split(';')
                      .slice(0, 5)"
                    :key="index"
                  >
                    <span>&ensp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="margin-left: 12px">{{ item }}</span>
                    <!-- <span @mouseover="hover($event,item)"
                    @mouseleave="leave">{{item}}</span>-->
                  </div>
                </div>
              </el-col>
              <el-col :span="12" style="height: 100%">
                <div>
                  个人简介：
                  <m-tips title="个人简介" content="简介初始来自系统对学者成果的自动摘要，学者认领后可自行修改。"></m-tips>
                </div>
                <ul class="infinite-list" style="overflow: auto; height: 100%; text-indent: 2em">
                  <li
                    v-if="nameOrgArray.introduction"
                    class="infinite-list-item"
                  >{{ nameOrgArray.introduction.trim() }}</li>
                </ul>
              </el-col>
            </el-row>
          </div>
          <div class="d-t-l-b">
            <keep-alive>
              <FoldBarChart :foldList="foldList" class="fold" v-loading="loading3"></FoldBarChart>
            </keep-alive>
          </div>
        </el-col>
        <el-col :span="6" style="height: 740px; display: flex; flex-direction: column">
          <div class="title" v-loading="loading2">
            <div
              v-for="item in titleList"
              :key="item.value"
              class="title-for"
              v-show="item.num !== 0"
            >
              <img :src="item.images" />
              <div class="title-right">
                <div style="color: #66776d">{{ item.num }}</div>
                <div style="font-size: 0.7em" class="title_tit">
                  <span>{{ item.value }}</span>
                  <span
                    style="
                      font-size: 0.6em;
                      word-break: break-all;
                      word-break: break-word;
                    "
                  >{{ item.english }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="qrcode" v-if="qrcodeUrl && !loading2">
            <img :src="qrcodeUrl" />
            <span>知领名片</span>
          </div>
        </el-col>
      </el-row>
      <!-- 成果列表部分 -->
      <div class="detail-body">
        <div class="left" v-loading="isLeftClick" v-if="isLeft">
          <div class="conditions" v-if="showAltName">
            <div class="resarch-theme">
              <span>
                人名拼写
                <m-tips
                  title="人名拼写"
                  content="由于中文姓名转为拼音拼写的复杂性，为了最大可能罗列学者的成果，系统穷举了可能所有拼音写法。您可以添加其他姓名写法和×选进行过滤，以便进行精确筛选。"
                ></m-tips>
              </span>
            </div>
            <div class="condition" v-if="altNameList.length">
              <span>可能拼写</span>
              <el-tag
                v-for="(tag, index) in altNameList"
                :key="index"
                closable
                @close="closeAltName(index)"
                type="info"
              >{{ tag }}</el-tag>
            </div>
            <div class="condition" v-if="altNameUsList.length">
              <span>可选拼写</span>
              <el-tag
                v-for="(tag, index) in altNameUsList"
                style="cursor: pointer"
                @click="clkAltName(tag)"
                :key="index"
                type="info"
                effect="plain"
              >{{ tag }}</el-tag>
            </div>
            <div class="condition">
              <span>添加姓名</span>
              <el-input ref="names" v-model="altName"></el-input>
              <el-button type="primary" @click="addAltName">添加筛选</el-button>
            </div>
          </div>
          <div class="border" v-if="showAltName"></div>
          <div class="conditions" v-if="showAltOrg">
            <div class="resarch-theme">
              <span>
                机构名称拼写
                <m-tips
                  title="机构名称拼写"
                  content="由于外文论文机构写法的不规则性，系统对外文成果的机构匹配尚不完善，您可以通过添加机构的外文写法进行成果过滤。"
                ></m-tips>
              </span>
            </div>
            <div class="condition" v-if="altOrgList.length">
              <span>可能拼写</span>
              <el-tag
                v-for="(tag, index) in altOrgList"
                style="cursor: pointer"
                :key="index"
                type="info"
                closable
                @close="closeAltOrg(index)"
              >{{ tag }}</el-tag>
            </div>
            <div class="condition" v-if="altOrgUsList.length">
              <span>可选拼写</span>
              <el-tag
                v-for="(tag, index) in altOrgUsList"
                style="cursor: pointer"
                @click="clkAltOrg(tag)"
                :key="index"
                type="info"
                effect="plain"
              >{{ tag }}</el-tag>
            </div>
            <div class="condition">
              <span>添加机构</span>
              <el-input v-model="altOrg"></el-input>
              <el-button type="primary" @click="addAltOrg">添加筛选</el-button>
            </div>
          </div>
          <div class="border" v-if="showAltOrg"></div>
          <div class="conditions" v-if="type.length || keywords.length || collList.length">
            <div class="resarch-theme">
              <span>当前检索条件</span>
              <el-tag closable type="info" @close="closeAll">全部清空</el-tag>
            </div>
            <div class="condition" v-if="type.length">
              <span>成果类型</span>
              <el-tag
                v-for="(tag, index) in type"
                :key="index"
                closable
                @close="closeName(tag)"
                type="info"
              >
                <span v-if="tag === 'J'">中文论文</span>
                <span v-if="tag === 'I'">SCI论文</span>
                <span v-if="tag === 'P'">专利</span>
                <span v-if="tag === 'E'">Ei</span>
                <span v-if="tag === 'A'">成果奖励</span>
                <span v-if="tag === 'B'">图书</span>
                <span v-if="tag === 'O'">项目</span>
                <span v-if="tag === 'C'">会议论文</span>
                <span v-if="tag === 'S'">标准</span>
                <span v-if="tag === 'D'">学位论文</span>
                <span v-if="tag === 'R'">报告</span>
                <span v-if="tag === 'Q'">其他</span>
                <span v-if="tag === 'U'">SCOPUS</span>
                <span v-if="tag === 'T'">团队</span>
                <span v-if="tag === 'Y'">活动</span>
              </el-tag>
            </div>
            <div class="condition" v-if="keywords.length">
              <span>研究主题</span>
              <el-tag
                v-for="(tag, index) in keywords"
                @close="closeKey(tag)"
                :key="index"
                closable
                type="info"
              >{{ tag }}</el-tag>
            </div>
            <div class="condition" v-if="collList.length">
              <span>相关学者</span>
              <el-tag
                v-for="(tag, index) in collList"
                :key="index"
                closable
                type="info"
                @close="closeColl(tag)"
              >{{ tag }}</el-tag>
            </div>
          </div>
          <div class="border" v-if="type.length || keywords.length || collList.length"></div>

          <div class="screening">
            <div class="screening-type">
              <div class="resarch-theme">
                <span>成果类型</span>
              </div>
              <div class="type">
                <!-- <el-tag type="info" v-for="(item,index) in typeList" :key="index">{{item.name}}</el-tag> -->
                <div v-for="(item, index) in typeList" :key="index">
                  <el-tag
                    style="cursor: pointer"
                    :key="item.name"
                    :effect="item.choose ? 'dark' : 'plain'"
                    :closable="item.choose"
                    @click="clkName(index)"
                    @close="closeName(item.key)"
                    type="info"
                  >
                    <span v-if="item.key === 'J'">中文论文</span>
                    <span v-if="item.key === 'I'">SCI论文</span>
                    <span v-if="item.key === 'P'">专利</span>
                    <span v-if="item.key === 'E'">EI</span>
                    <span v-if="item.key === 'A'">成果奖励</span>
                    <span v-if="item.key === 'B'">图书</span>
                    <span v-if="item.key === 'O'">项目</span>
                    <span v-if="item.key === 'C'">会议论文</span>
                    <span v-if="item.key === 'S'">标准</span>
                    <span v-if="item.key === 'D'">学位论文</span>
                    <span v-if="item.key === 'R'">报告</span>
                    <span v-if="item.key === 'Q'">其他</span>
                    <span v-if="item.key === 'U'">SCOPUS</span>
                    <span v-if="item.key === 'T'">团队</span>
                    <span v-if="item.key === 'Y'">活动</span>
                  </el-tag>
                </div>
              </div>
            </div>
          </div>
          <div class="border" v-if="Object.keys(topKeywords).length"></div>
          <div class="research" v-if="Object.keys(topKeywords).length">
            <div class="resarch-theme">
              <span>研究主题</span>
            </div>
            <div class="simkeyword segment hone">
              <div class="simkeywords">
                <el-tag
                  v-for="(tag, index) in topKeywords"
                  :key="tag.key"
                  :effect="tag.choose ? 'dark' : 'plain'"
                  :closable="tag.choose"
                  @click="clkKey(index)"
                  @close="closeKey(tag.key)"
                  type="info"
                >{{ tag.key }}</el-tag>
              </div>
            </div>
          </div>
          <div class="border" v-if="coauthors.length && isCode"></div>
          <div class="research" v-if="coauthors.length && isCode">
            <div class="resarch-theme">
              <span>相关学者</span>
            </div>
            <div class="scholars">
              <el-checkbox-group class="scholars-related" v-model="collList" @change="clkRes">
                <el-checkbox
                  class="checked"
                  v-for="(item, index) in coauthors"
                  :label="item.key"
                  :key="index"
                >
                  {{ item.key }}
                  <div class="scholars-bar">
                    <div
                      :style="{
                        width:
                          (item.doc_count / coauthors[0].doc_count) * 100 + '%',
                      }"
                      class="scholars-bars"
                    ></div>
                  </div>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div class="detail-main" :style="{ width: radio === '1' ? '68%' : '100%' }">
          <div class="main-option">
            <div>
              <el-radio-group
                v-model="radio"
                class="ridio1"
                fill="#6a8b89"
                @change="isLeft = radio === '1' ? true : false"
              >
                <el-radio-button label="1">成果列表</el-radio-button>
                <el-radio-button label="2">可视化统计</el-radio-button>
              </el-radio-group>
              <span
                style="margin-left: 20px"
                v-if="resultsData.total && radio === '1'"
              >已经为您检索出{{ resultsData.total }}条成果</span>
            </div>

            <div v-if="radio === '1'">
              <span style="margin-right: 10px">排序</span>
              <el-select v-model="sort" placeholder="请选择" style="width: 140px" @change="select">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
          <keep-alive>
            <menu1
              :loading="loading4"
              :isLeftClick="isLeftClick"
              :is="radio === '1' ? 'menu1' : 'menu2'"
              :ThemList="ThemList"
              :resultsData="resultsData"
              :subjectList="subjectList"
              :keyword="keyword"
              :research="research"
              @menuPage="getPage"
              @select="selectType"
            ></menu1>
          </keep-alive>
        </div>
      </div>
      <el-dialog v-loading="loading6" title="提 示" :visible.sync="dialogVisible" width="30%">
        <span>{{ msg }}</span>
        <div
          style="
            display: flex;
            flex-direction: row;
            margin-top: 20px;
            align-items: center;
          "
          v-if="vldMobile"
        >
          <span>手机号：</span>
          <el-input placeholder="请输入手机号" v-model="Mobile" style="width: 80%; margin-right: 20px"></el-input>
        </div>
        <div
          style="
            display: flex;
            flex-direction: row;
            margin-top: 20px;
            align-items: center;
          "
          v-if="vldMobile"
        >
          <span>验证码：</span>
          <el-input placeholder="请输入手机验证码" v-model="code" style="width: 60%; margin-right: 20px"></el-input>
          <el-button
            type="primary"
            :disabled="codeTxt !== '重新获取' && codeTxt !== '获取验证码'"
            @click="getMblCode()"
          >{{ codeTxt }}</el-button>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="claiming()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import menu1 from './Menu/menu1'
import menu2 from './Menu/menu2'
import mTips from '@/components/m-tips/m-tips'
import $ from 'jquery'
import { isNum, login } from '@/utils/index'
import FoldBarChart from '@/components/Charts/FoldBarChart'
import { saveUser, getCode, getBase64Avatar } from '@/api/center'
import { checkexpertid,
  getUser,
  getForkid,
  isAcademician,
  getOrgArray,
  getQueryResources,
  getQueryAcademicStats,
  getYearKey,
  getQueryResourcesNew,
  setClaim,
  getSum,
  isPath,
  getOrg
} from '@/api/detail'

export default {
  name: 'Details',
  components: {
    mTips,
    menu1,
    menu2,
    FoldBarChart
  },
  data () {
    return {
      user: localStorage.getItem('user'), // user
      radio: '1', // 成果列表和可视化统计切换
      isLeft: true, // 是否显示左侧栏
      titleList: [
        {
          value: '中文论文/',
          english: 'Papers',
          images: 'static/img/icon/papers.png',
          num: 0,
          code: 'J'
        },
        {
          value: '科学引文索引/',
          english: 'Sci',
          images: 'static/img/icon/sci.png',
          num: 0,
          code: 'I'
        },
        {
          value: '专利/',
          english: 'Patents',
          images: 'static/img/icon/patent.png',
          num: 0,
          code: 'P'
        },
        {
          value: '工程索引/',
          english: 'Ei',
          images: 'static/img/icon/EI.png',
          num: 0,
          code: 'E'
        },
        {
          value: '图书/',
          english: 'Books',
          images: 'static/img/icon/books.png',
          num: 0,
          code: 'B'
        },
        {
          value: '成果奖励/',
          english: 'Achievements',
          num: 0,
          images: 'static/img/icon/reward.png',
          code: 'A'
        },
        {
          value: '项目/',
          english: 'Projects',
          images: 'static/img/icon/project.png',
          num: 0,
          code: 'O'
        },
        {
          value: '',
          english: 'scopus',
          images: 'static/img/icon/scopus.png',
          num: 0,
          code: 'U'
        }
      ], // 成果类型统计
      options: [
        {
          value: '选项1',
          label: '按时间降序'
        },
        {
          value: '选项2',
          label: '按时间升序'
        }
      ], // 排序
      sort: '选项1', // 成果列表排序
      sortType: '选项1', // 研究聚焦排序
      sortLang: 'all', // 研究聚焦语言
      nameOrgArray: { introduction: '' }, // 专家信息
      avatarUrl: '', // 从另外一个接口获取头像信息
      kId: this.$route.query.kId || this.$route.query.kid, // 带入KID
      keyword: this.$route.query.keyword, // 带入关键词
      name: this.$route.query.name, // 带入信息
      institute: this.$route.query.institute, // 带入机构
      /* loading */
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,
      loading5: false,
      loading6: false,

      acadUrl: '', // 院士馆链接
      isPath: false, // 是否可以跳转人才查询
      isLeftClick: true, // 左侧是否可以点击
      foldList: {}, // 成果列表echart数据
      subjectList: [], // 学科分布数组
      ThemList: [], // 成果分布数组
      typeList: [], // 成果类型数组
      type: [], // 选中成果类型
      resultsData: {}, // 成果列表
      from: 0, // 页数
      research: {}, // 研究焦距
      isShow: true,
      topKeywords: [], // 研究主题
      keywords: [], // 选中主题
      coauthors: [], // 相关学者
      collList: [], // 选中相关学者
      isCode: true, // 是否 显示相关学者
      qrcodeUrl: '', // 二维码URL
      jump: 0, // 认领时所跳转的页面
      dialogVisible: false, // 认领弹窗控制
      vldMobile: false, // 是否显示手机号输入框
      msg: '', // 认领窗口文字
      code: '', // 验证码
      Mobile: '', // 手机号
      codeTxt: '获取验证码', // 验证按钮文字
      altName: '', // 手动添加人名
      altOrg: '', // 手动添加机构名
      altNameList: [], // 已有人名
      altOrgList: [], // 已有机构名
      altNameListClone: [], // 克隆已有人名
      altOrgListClone: [], // 克隆已有机构
      showAltName: true,
      showAltOrg: true,
      altNameUsList:
        JSON.parse(localStorage.getItem(this.$route.query.kId + 'altName')) ||
        [], // 可选人名
      altOrgUsList:
        JSON.parse(localStorage.getItem(this.$route.query.kId + 'altOrg')) || [] // 可选机构
    }
  },

  async created () {
    this.loading1 = true
    let data = {}
    let isKIdFlag = false // 加密之后的KId
    if (this.kId) {
      if (isNaN(this.kId)) {
        await this.checkexpertid(this.kId).then(res => {
          if (res.status == 1) {
            isKIdFlag = true
            this.kId = res.data.kId
          }
        })
        if (!isKIdFlag) {
          // 解密之后仍然查不到KId
          this.$message('专家信息不存在')
          setTimeout(() => {
            this.$router.push({ name: 'Home' })
          }, 1000)
          return
        }
      }
      data = {
        kId: this.kId
      }
      this.getBase64Avatar(this.kId)
    } else {
      data = {
        name: this.name,
        institute: this.institute
      }
    }
    // 获取专家信息
    getOrgArray(data)
      .then(res => {
        this.loading1 = false
        if (!res[0].isValid) {
          this.$alert('此kId无有效专家信息，正在为你跳转系统首页', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.push({ name: 'Home' })
            }
          })
        }
        this.nameOrgArray = res[0]
        // this.getSubject(this.nameOrgArray.subject.split(';')[0])
        localStorage.setItem('nameOrgArray', JSON.stringify(this.nameOrgArray))
        if (!this.kId) {
          this.getSum(res)
        }
        if (/^\d+$/.test(this.nameOrgArray.kId)) {
          this.getCode()
        }
        isPath({
          name: this.nameOrgArray.name,
          org: this.nameOrgArray.organization
        }).then(res => {
          this.isPath = !!res.data.length
        })
        this.getData()
      })
      .catch(err => {
        console.log(err)
      })
  },
  mounted () {},
  methods: {
    checkexpertid (kid) {
      var that = this
      return new Promise(resolve => {
        checkexpertid({ kid: kid }).then(res => {
          if (res.data) {
            resove(res)
          }
        })
      })
    },
    getBase64Avatar (kId) {
      var that = this
      getBase64Avatar({ kId: kId }).then(res => {
        if (res.data && res.data.length) {
          if (res.data[0].data.length && res.data[0].data[0].avatar) {
            this.avatarUrl = res.data[0].data[0].avatar.replace(/[\r\n]/g, '')
          }
          //  that.$set(that.expert,index,expertIndex)
        }
      })
    },
    // 获取数据
    getData () {
      this.loading2 = true
      this.loading3 = true
      this.isLeftClick = true
      let temp = []
      let keywords = []
      let _this = this
      if (this.keyword) {
        // keywords = this.keyword.split(" ");
        // this.keywords = keywords;
        this.keywords = [this.keyword]
      }
      temp[0] = this.nameOrgArray
      let altNameList = this.nameOrgArray.altName
        ? this.nameOrgArray.altName
          .split(';')
          .splice(0, this.nameOrgArray.altName.split(';').length - 1)
        : []

      let altOrgList = this.nameOrgArray.altOrganization
        ? this.nameOrgArray.altOrganization
          .split(';')
          .splice(0, this.nameOrgArray.altOrganization.split(';').length - 1)
        : []

      this.altNameListClone = [...altNameList]
      console.log('altNameListClone', this.altNameListClone)
      altNameList.forEach(it => {
        if (!/.*[\u4e00-\u9fa5]+.*$/.test(it)) {
          this.altNameList.push(it)
        }
      })
      altOrgList.forEach(it => {
        if (!/.*[\u4e00-\u9fa5]+.*$/.test(it)) {
          this.altOrgList.push(it)
        }
      })
      if (!altOrgList.length && !this.altOrgUsList.length) {
        this.nameOrgArray.organization.split(';').forEach(it => {
          let data = {
            name: it
          }
          getOrg(data).then(res => {
            if (
              res.data.data.result.length &&
              res.data.data.result[0].shortNameAlt
            ) {
              this.altOrgUsList.push(res.data.data.result[0].shortNameAlt)
              this.altOrgListClone.push(res.data.data.result[0].shortNameAlt)
              console.log('altOrgListClone', this.altOrgListClone)
            }
          })
        })
      }
      let data2 = {}
      let data = {}
      let altName = ''
      let altOrg = ''
      this.altNameList.forEach(it => {
        altName = altName + it + ';'
      })
      this.altOrgList.forEach(it => {
        altOrg = altOrg + it + ';'
      })
      if (this.kId) {
        data = {
          excludeBook: true,
          isClaim: '1',
          kId: parseInt(this.kId),
          nameOrgArray: temp
        }
        data2 = {
          from: 0,
          isClaimed: 1,
          kId: parseInt(this.kId),
          keywords: keywords,
          order: 'desc',
          size: 10,
          sort: 'year',
          ck: this.keywords,
          altName: altName,
          altOrganization: altOrg
        }
        getQueryResourcesNew(data2)
          .then(res => {
            this.isLeftClick = false
            this.resultsData = res
            if (this.keyword) {
              this.getTitData()
            } else {
              this.typeList = res.topResources.map(it => {
                return {
                  doc_count: it.doc_count,
                  key: it.key,
                  choose: false
                }
              })
              this.loading2 = false
              res.topResources.forEach((item, index) => {
                this.titleList.forEach((items, indexs) => {
                  if (item.key === items.code) {
                    this.titleList[indexs].num = parseFloat(
                      item.doc_count
                    ).toLocaleString()
                  }
                })
              })
            }

            if (res.obj.length === 0) {
              this.keywords = []
              this.getPage(0)
              return
            }
            this.coauthors = res.topCoauthors
            res.topKeywords.forEach((item, index) => {
              if (item.key === '?') {
                return false
              }
              let temp = {
                key: item.key,
                choose: false
              }
              this.topKeywords.push(temp)
            })
          })
          .catch(err => {
            console.log(err)
          })
        isAcademician({ kId: this.kId }).then(res => {
          if (res.code === 0) {
            this.acadUrl = res.data.url
          }
        })
      } else {
        data = {
          excludeBook: true,
          nameOrgArray: temp
        }
        data2 = {
          from: 0,
          nameOrgArray: temp,
          order: 'desc',
          keywords: keywords,
          size: 10,
          sort: 'year',
          altName: altName,
          altOrganization: altOrg
        }
        getForkid(data2).then(res => {
          this.isLeftClick = false
          this.resultsData = res

          if (this.keyword) {
            this.getTitData()
          } else {
            this.loading2 = false
            res.topResources.forEach((item, index) => {
              this.titleList.forEach((items, indexs) => {
                if (item.key === items.code) {
                  this.titleList[indexs].num = parseFloat(
                    item.doc_count
                  ).toLocaleString()
                }
              })
            })
          }
          if (res.obj.length === 0) {
            this.keywords = []
            this.getPage(0)
            return
          }
          this.typeList = res.topResources
          this.typeList.forEach((item, index) => {
            this.typeList[index].choose = false
          })
          this.coauthors = res.topCoauthors
          res.topKeywords.forEach((item, index) => {
            let temp = {
              key: item.key,
              choose: false
            }
            this.topKeywords.push(temp)
          })
        })
      }

      getQueryAcademicStats(data)
        .then(res => {
          this.loading3 = false
          this.ThemList = res.obj.stats1
          this.foldList = res.obj.stats1
        })
        .catch(err => {
          console.log(err)
        })
      getQueryResources(data2)
        .then(res => {
          res.obj.stats1.subject[0].subjects.forEach((item, index) => {
            this.subjectList.push({ name: item.subject, count: item.count })
          })
        })
        .catch(err => {
          console.log(err)
        })

      this.getKey()
    },
    //  获取成果数量
    getTitData () {
      let temp = []
      temp[0] = this.nameOrgArray
      let data2 = {}
      let altName = ''
      let altOrg = ''
      this.altNameList.forEach(it => {
        altName = altName + it + ';'
      })
      this.altOrgList.forEach(it => {
        altOrg = altOrg + it + ';'
      })
      if (this.kId) {
        data2 = {
          from: 0,
          isClaimed: 1,
          kId: parseInt(this.kId),
          order: 'desc',
          size: 10,
          sort: 'year',
          ck: this.keywords,
          altName: altName,
          altOrganization: altOrg
        }
        getQueryResourcesNew(data2)
          .then(res => {
            this.loading2 = false
            this.typeList = res.topResources.map(it => {
              return {
                doc_count: it.doc_count,
                key: it.key,
                choose: false
              }
            })
            res.topResources.forEach((item, index) => {
              this.titleList.forEach((items, indexs) => {
                if (item.key === items.code) {
                  this.titleList[indexs].num = parseFloat(
                    item.doc_count
                  ).toLocaleString()
                }
              })
            })
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        data2 = {
          from: 0,
          nameOrgArray: temp,
          order: 'desc',
          size: 10,
          altName: altName,
          altOrganization: altOrg,
          sort: 'year'
        }
        getForkid(data2).then(res => {
          this.loading2 = false
          this.typeList = res.topResources.map(it => {
            return {
              doc_count: it.doc_count,
              key: it.key,
              choose: false
            }
          })
          res.topResources.forEach((item, index) => {
            this.titleList.forEach((items, indexs) => {
              if (item.key === items.code) {
                this.titleList[indexs].num = parseFloat(
                  item.doc_count
                ).toLocaleString()
              }
            })
          })
        })
      }
    },
    // 获取简历
    getSum (data) {
      let temp = {
        nameOrgArray: data
      }
      getSum(temp).then(res => {
        let info = res.stats
        let chineseData = {}
        let chineseDetailData = {}
        let chineseSourceStr = ''
        let englishData = {}
        let englishDetailData = {}
        let englishSourceStr = ''
        let categoryCount = 0
        let totalCount = 0
        let areaStr = ''
        let that = this
        info.language.forEach((item, index) => {
          if (item.name === '外文') {
            englishData = item
            englishDetailData = item.top1[0]._source
            totalCount += item.count
            englishData.journal.forEach(function (e) {
              categoryCount++
              englishSourceStr += e.name + '、'
            })
          } else {
            chineseData = item
            chineseDetailData = item.top1[0]._source
            totalCount += item.count
            chineseData.journal.forEach(function (e) {
              categoryCount++
              chineseSourceStr += e.name + '、'
            })
            chineseData.subject.forEach(function (e) {
              areaStr += e.name + '、'
            })
          }
        })
        let sourceStr = chineseSourceStr + englishSourceStr
        sourceStr = sourceStr.substr(0, sourceStr.length - 1)
        areaStr = areaStr.substr(0, areaStr.length - 1)
        if (!englishSourceStr) {
          if (chineseDetailData.year === undefined) {
            that.nameOrgArray.introduction = '暂无简历信息'
          } else {
            areaStr = areaStr
              ? '篇，其研究领域主要集中在' + areaStr + '等方向。'
              : '篇。'
            this.nameOrgArray.introduction =
              '根据数据搜索表明' +
                that.nameOrgArray.name +
                '（专家）可见的最早中文论文发表是' +
                chineseDetailData.year ===
              2020
                ? 2019
                : // chineseDetailData.year +
                // "年在" +
                '共计在' +
                    chineseDetailData.journal +
                    '（期刊）上的' +
                    chineseDetailData.title +
                    '一文。' +
                    '截至' +
                    parseInt(info.year) ===
                  2020
                  ? 2019
                  : // info.year +
                  // "年在" +
                  '共计在' +
                  sourceStr +
                  '等' +
                  categoryCount +
                  '种期刊上共发文' +
                  totalCount +
                  areaStr
          }
        } else if (!chineseSourceStr) {
          that.nameOrgArray.introduction =
            '根据数据搜索表明' +
              that.nameOrgArray.name +
              '（专家）可见的最早英文论文发表是' +
              englishDetailData.year +
              '年在' +
              englishDetailData.journal +
              '（期刊）上的' +
              englishDetailData.title +
              '一文。' +
              '截至' +
              parseInt(info.year) ===
            2020
              ? 2019
              : // info.year +"年在" +
              '共计在' +
                sourceStr +
                '等' +
                categoryCount +
                '种期刊上共发文' +
                totalCount +
                '篇。'
        } else if (englishSourceStr === '' && chineseSourceStr === '') {
          this.nameOrgArray.introduction = '暂无简历信息'
        } else {
          areaStr = areaStr
            ? '篇，其研究领域主要集中在' + areaStr + '等方向。'
            : '篇。'
          this.nameOrgArray.introduction =
            '根据数据搜索表明' +
              this.nameOrgArray.name +
              '（专家）可见的最早中文论文发表是' +
              parseInt(chineseDetailData.year) ===
            2020
              ? 2019
              : chineseDetailData.year +
                  '年在' +
                  chineseDetailData.journal +
                  '（期刊）上的' +
                  chineseDetailData.title +
                  '一文，最早英文论文发表是' +
                  parseInt(englishDetailData.year) ===
                2020
                ? 2019
                : //  englishDetailData.year +
              //   "年在" +
                '共计在' +
                  englishDetailData.journal +
                  '（期刊）上的' +
                  englishDetailData.title +
                  '一文。' +
                  '截至' +
                  parseInt(info.year) ===
                2020
                  ? 2019
                  : // info.year +
                // "年在" +
                  '共计在' +
                sourceStr +
                '等' +
                categoryCount +
                '种期刊上共发文' +
                totalCount +
                areaStr
        }
        this.nameOrgArray.introduction = this.nameOrgArray.introduction.replace(
          /\(/g,
          '（'
        )
        this.nameOrgArray.introduction = this.nameOrgArray.introduction.replace(
          /\)/g,
          '）'
        )
        // eslint-disable-next-line no-useless-escape
        this.nameOrgArray.introduction = this.nameOrgArray.introduction.replace(
          /\),/g,
          '，'
        )
      })
    },
    // 获取研究聚焦
    getKey () {
      let data
      this.loading4 = true
      if (this.kId) {
        data = {
          kId: this.kId,
          type: this.sortType !== '选项1' ? 'asc' : 'desc',
          lang: this.sortLang
        }
      } else {
        data = {
          name: this.nameOrgArray.name,
          institute: this.nameOrgArray.organization,
          type: this.sortType !== '选项1' ? 'asc' : 'desc',
          lang: this.sortLang
        }
      }
      getYearKey(data)
        .then(res => {
          this.loading4 = false
          let i = 0
          res.data.data.forEach((item, index) => {
            if (item.keywords.length) {
              this.research[i] = item
              i++
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 分页查询
    getPage (from, remakr) {
      this.isLeftClick = true
      if (typeof from === 'number') {
        this.from = from
      } else {
        this.from = 0
      }
      let formNum = this.from
      let order = ''
      let sort = ''
      if (this.sort === '选项1') {
        order = 'desc'
        sort = 'year'
      } else if (this.sort === '选项2') {
        order = 'asc'
        sort = 'year'
      }
      let data = {}
      let altName = ''
      let altOrg = ''
      this.altNameList.forEach(it => {
        altName = altName + it + ';'
      })
      this.altOrgList.forEach(it => {
        altOrg = altOrg + it + ';'
      })
      if (isNum(this.kId)) {
        data = {
          from: formNum,
          isClaimed: 1,
          kId: parseInt(this.kId),
          order: order,
          size: 10,
          sort: sort,
          resource: this.type,
          keywords: this.keywords,
          coauthor: this.collList,
          ck: this.keywords,
          altName: altName,
          altOrganization: altOrg
        }
        getQueryResourcesNew(data)
          .then(res => {
            this.isLeftClick = false
            this.resultsData = res
            let temp = []
            res.topKeywords.forEach(it => {
              if (it.key === '?') {
                return false
              } else {
                temp.push({
                  key: it.key,
                  choose: false
                })
              }
            })

            this.keywords.forEach((item, index) => {
              temp.forEach((val, i) => {
                if (item === val.key) {
                  temp.splice(i, 1)
                }
              })
            })
            let keys = this.keywords.map(it => {
              return {
                key: it,
                choose: true
              }
            })
            this.topKeywords = keys.concat(temp)

            if (this.isShow) {
              this.coauthors = res.topCoauthors
            }
            if (remakr === 'key') {
              this.typeList = res.topResources
              this.typeList.forEach((item, index) => {
                let check = false
                for (let i = 0; i < this.type.length; i++) {
                  if (item.key === this.type[i]) {
                    check = true
                  }
                }
                this.typeList[index].choose = check
              })
            }
            this.isShow = true
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        let temp = []
        temp[0] = this.nameOrgArray
        data = {
          from: formNum,
          isClaimed: 1,
          nameOrgArray: temp,
          order: order,
          size: 10,
          sort: sort,
          altName: altName,
          altOrganization: altOrg,
          resource: this.type,
          keywords: this.keywords,
          coauthor: this.collList
        }
        getForkid(data)
          .then(res => {
            this.isLeftClick = false
            this.resultsData = res
            let temp = res.topKeywords.map(it => {
              return {
                key: it.key,
                choose: false
              }
            })
            this.keywords.forEach((item, index) => {
              temp.forEach((val, i) => {
                if (item === val.key) {
                  temp.splice(i, 1)
                }
              })
            })
            let keys = this.keywords.map(it => {
              return {
                key: it,
                choose: true
              }
            })
            this.topKeywords = keys.concat(temp)
            if (this.isShow) {
              this.coauthors = res.topCoauthors
            }
            console.log(remakr)
            if (remakr === 'key') {
              this.typeList = res.topResources
              this.typeList.forEach((item, index) => {
                let check = false
                for (let i = 0; i < this.type.length; i++) {
                  if (item.key === this.type[i]) {
                    check = true
                  }
                }
                this.typeList[index].choose = check
              })
            }
            this.isShow = true
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    // 研究聚焦下拉选择修改
    selectType (data) {
      this.sortType = data.type
      this.sortLang = data.lang
      this.getKey()
    },
    // 选中排序
    select (val) {
      this.getPage()
    },
    // 图片加载失败
    errImg () {
      this.nameOrgArray.avatarUrl = ''
    },
    // 认领开始
    claim () {
      if (isNum(this.nameOrgArray.kId)) {
        return
      }
      if (this.user) {
        this.dialogVisible = true
        this.msg = '确定要认领吗'
      } else {
        this.msg = '认领失败，请先登录'
        this.$alert('请先登录', '认领失败', {
          confirmButtonText: '确定',
          callback: action => {
            login()
          }
        })
      }
    },
    // 认领中
    claiming () {
      let user = JSON.parse(this.user)
      if (this.jump === 1) {
        user.Code = this.code
        user.Mobile = this.Mobile
        this.loading6 = true
        saveUser(user).then(res => {
          if (res.status) {
            localStorage.setItem('user', JSON.stringify(res.data.Data))
            this.user = JSON.stringify(res.data.Data)
            this.setClaim()
          } else {
            this.loading6 = false
            this.$message({
              showClose: true,
              message: res.msg,
              offset: 200
            })
          }
        })
        return
      }
      if (this.jump === 2) {
        this.$router.push({
          path: 'center',
          query: { data: '1' }
        })
        return
      }
      if (!user.Mobile || user.Mobile === 'null') {
        this.msg =
          '您正在认领' +
          this.nameOrgArray.name +
          '专家，由于认领操作将影响专家数据，需要您进行手机号验证后可进行后续认领操作。'
        this.vldMobile = true
        this.jump = 1
        return
      }
      this.loading6 = true
      this.setClaim()
    },
    // 认领
    setClaim () {
      let user = JSON.parse(this.user)
      let data = {}
      let permission = []
      data = {
        UserId: user.Id,
        ExpertName: this.nameOrgArray.name,
        ExpertOrganization: this.nameOrgArray.organization,
        IsValid: '1',
        PageSize: 0,
        PageIndex: 0
      }
      for (var i = 0; i < user.Roles.length; i++) {
        for (var j = 0; j < user.Roles[i].Permissions.length; j++) {
          permission.push(user.Roles[i].Permissions[j].Id)
        }
      }
      permission.forEach((item, index) => {
        if (item === 'UserFunc102') {
          data.ExpertOrganization = ''
        }
      })
      // }
      setClaim(data)
        .then(res => {
          if (res.status === 0) {
            if (res.msg === '认证失败，您已认领过专家。') {
              getUser({ PageIndex: 1, PageSize: 24 }).then(res => {
                this.loading6 = false
                this.msg =
                  '认领失败，按规则一个账户仅可认领一位专家，您已经认领过' +
                  res.data.Data[0].PermitUserName +
                  '专家，点击确认按钮查看。'
                this.jump = 2
              })
            } else {
              this.loading6 = false
              this.msg = res.msg
            }
          } else {
            this.loading6 = false
            this.msg = res.msg
            localStorage.setItem(
              'nameOrgArray',
              JSON.stringify(this.nameOrgArray)
            )
            localStorage.setItem('cid', res.cid)
            this.$router.push({
              path: '/claim/basic',
              query: { cid: res.cid }
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取手机验证码
    getMblCode () {
      if (!this.Mobile) {
        this.$message('请输入手机号')
        return
      }
      if (!/^1[3456789]\d{9}$/.test(this.Mobile)) {
        this.$message('请输入正确的手机号')
        return
      }
      this.loading6 = true
      let data = {
        Mobile: this.Mobile,
        Operate: 1
      }
      getCode(data).then(res => {
        this.loading6 = false
        if (res.status === 1) {
          const TIME_COUNT = 59
          this.times = TIME_COUNT
          this.timer = setInterval(() => {
            if (this.times > 0 && this.times <= 59) {
              this.codeTxt = this.times
              this.times--
            } else {
              this.codeTxt = '重新获取'
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        } else {
          this.dialogVisible = false
          this.$message(res.msg)
        }
      })
    },
    // 点击成果类型
    clkName (index) {
      if (this.typeList[index].choose === true) {
        return
      }
      this.typeList[index].choose = true
      this.type.push(this.typeList[index].key)
      this.getPage()
    },
    // 清除成果类型
    closeName (val) {
      this.typeList.forEach((item, index) => {
        if (item.key === val) {
          this.typeList[index].choose = false
        }
      })
      let i = this.type.findIndex(item => {
        if (item === val) {
          return true
        }
      })
      this.type.splice(i, 1)
      this.getPage()
    },
    // 点击研究主题
    clkKey (index) {
      if (this.topKeywords[index].choose === true) {
        return
      }
      this.topKeywords[index].choose = true
      this.keywords.push(this.topKeywords[index].key)
      this.getPage()
    },
    // 清除研究主题
    closeKey (val) {
      this.topKeywords.forEach((item, index) => {
        if (item.key === val) {
          this.topKeywords[index].choose = false
        }
      })
      let i = this.keywords.findIndex(item => {
        if (item === val) {
          return true
        }
      })
      this.keywords.splice(i, 1)
      this.getPage()
    },
    // 点击相关学者
    clkRes (value) {
      this.isShow = false
      this.getPage()
    },
    //  清除相关学者
    closeColl (name) {
      let i = this.collList.findIndex(item => {
        if (item === name) {
          return true
        }
      })
      this.collList.splice(i, 1)
      this.getPage()
    },
    // 清除全部
    closeAll () {
      this.type = []
      this.collList = []
      this.keywords = []
      this.topKeywords.forEach((item, index) => {
        this.topKeywords[index].choose = false
      })
      this.typeList.forEach((item, index) => {
        this.typeList[index].choose = false
      })
      this.getPage()
    },
    // 获取二维码
    getCode () {
      let that = this
      $.ajax({
        type: 'post',
        url: 'https://card.heidutech.com/api/coon/getqrcode',
        data: {
          kid: that.nameOrgArray.kId
        },
        dataType: 'json',
        success: function (res) {
          if (!res.code) {
            that.qrcodeUrl = res.data.qrcode
          }
        }
      })
    },
    // 添加人名
    addAltName () {
      this.$message.closeAll()
      if (this.altNameList.indexOf(this.altName) > -1) {
        this.$message({
          showClose: true,
          message: '已有该人名！',
          offset: 200
        })
        return
      }

      if (!this.altName) {
        this.$message({
          showClose: true,
          message: '请输入人名！',
          offset: 200
        })
        return
      }
      if (/.*[\u4e00-\u9fa5]+.*$/.test(this.altName)) {
        this.$message({
          showClose: true,
          message: '请勿输入中文！',
          offset: 200
        })
        return
      }
      if (this.altNameUsList.indexOf(this.altName) === -1) {
        // this.altNameUsList.push(this.altName);
        this.altNameList.push(this.altName)
        // localStorage.setItem(this.kId+'altName', JSON.stringify(this.altNameUsList));
        this.getPage(0, 'key')
        this.altName = ''
      } else {
        this.$message({
          showClose: true,
          message: '已有该人名！',
          offset: 200
        })
      }
    },
    // 添加机构
    addAltOrg () {
      this.$message.closeAll()
      if (this.altOrgList.indexOf(this.altOrg) > -1) {
        this.$message({
          showClose: true,
          message: '已有该机构名！',
          offset: 200
        })
        return
      }

      if (!this.altOrg) {
        this.$message({
          showClose: true,
          message: '请输入机构名！',
          offset: 200
        })
        return
      }
      if (/.*[\u4e00-\u9fa5]+.*$/.test(this.altOrg)) {
        this.$message({
          showClose: true,
          message: '请勿输入中文！',
          offset: 200
        })
        return
      }
      if (this.altOrgUsList.indexOf(this.altOrg) === -1) {
        // this.altOrgUsList.push(this.altOrg);
        this.altOrgList.push(this.altOrg)
        localStorage.setItem(
          this.kId + 'altOrg',
          JSON.stringify(this.altOrgUsList)
        )
        this.getPage(0, 'key')
        this.altOrg = ''
      } else {
        this.$message({
          showClose: true,
          message: '已有该机构名！',
          offset: 200
        })
      }
    },
    // 选中人名
    clkAltName (tag) {
      this.altNameList.push(tag)
      let index = this.altNameUsList.indexOf(tag)
      this.altNameUsList.splice(index, 1)
      this.getPage(0, 'key')
    },
    // 删除人名
    closeAltName (index) {
      this.altNameUsList.push(this.altNameList[index])
      this.altNameList.splice(index, 1)
      this.getPage(0, 'key')
    },
    // 选中机构
    clkAltOrg (tag) {
      this.altOrgList.push(tag)
      let index = this.altOrgUsList.indexOf(tag)
      this.altOrgUsList.splice(index, 1)
      this.getPage(0, 'key')
    },
    // 删除机构
    closeAltOrg (index) {
      this.altOrgUsList.push(this.altOrgList[index])
      this.altOrgList.splice(index, 1)
      this.getPage(0, 'key')
    },
    // 人才发现跳转
    talent () {
      window.open(
        'http://183.136.237.195/expert/#/?name=' +
          this.nameOrgArray.name +
          '&org=' +
          this.nameOrgArray.organization
      )
    },

    // 院士馆跳转
    goAcad () {
      window.open(this.acadUrl)
    }
  },
  computed: {
    titleListClone () {
      return this.titleList
    }
  },
  watch: {
    titleListClone: {
      deep: true,
      handler (val) {
        if (val[1].num && !localStorage.getItem('detailTips')) {
          localStorage.setItem('detailTips', 1)
          let _this = this
          this.$alert(
            '检测到当前专家拥有外文论文成果，您可以在成果列表左侧添加姓名、机构写法进行过滤，以便进行精确筛选。',
            {
              confirmButtonText: '去检索',
              cancelButtonText: '知道了',
              showCancelButton: true,
              callback: action => {
                if (action == 'confirm') {
                  this.$refs.names.$el.children[0].focus()
                  // _this.$refs.names.$el.querySelector("input").focus();
                }
              }
            }
          )
        }
      }
    },
    type: {
      deep: true,
      handler (val) {
        this.isCode = false
        if (!val.length) {
          this.isCode = true
          return
        }
        if (val.length === 1) {
          if (val[0] === 'I' || val[0] === 'E') {
            this.showAltName = true
            this.showAltOrg = true
          } else {
            this.showAltName = false
            this.showAltOrg = false
          }
        } else {
          this.showAltName = false
          this.showAltOrg = false
        }
        val.forEach((item, index) => {
          if (item === 'J' || item === 'I') {
            this.isCode = true
          }
        })
      }
    },

    dialogVisible: {
      deep: true,
      handler () {
        this.vldMobile = false
        this.Mobile = ''
        this.code = ''
      }
    }
  }
}
</script>

<style lang="scss">
@mixin ell($line) {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: $line;
  -webkit-box-orient: vertical;
}
.txovh {
  @include ell(5);
}
.txovh6 {
  @include ell(6);
}
.detail {
  .el-dialog__header {
    text-align: center;
  }

  .d-t {
    width: 92vw;
    min-height: 650px;
    background: #fff;
    margin-bottom: 30px;
    padding: 40px 0;
    z-index: 2;
    min-width: 1200px;
    .d-t-br {
      height: 100%;
      padding: 30px;
      border-right: 2px solid #000;
      .d-t-l-h {
        height: 100%;
        ::-webkit-scrollbar {
          width: 6px;
          background-color: #f2f2f2;
        }
        ::-webkit-scrollbar-thumb {
          background-color: #dedede;
        }
        .d-t-header {
          img {
            display: block;
            width: 100%;
          }
        }
        .detail {
          p {
            margin-top: 1vh;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          a {
            margin-top: 1vh;
          }
          .keywords {
            height: 70px;
            overflow: hidden;
            margin-top: 1vh;
            .el-tag {
              margin: 0 8px 6px 0;
            }
          }
          .el-button {
            margin-top: 1vh;
          }
          .subjcetTit {
            margin-top: 1vh;
          }
          .subject {
            width: auto;
            display: block;
          }
          .disabled {
            color: #fff;
            background-color: #a0cfff;
            border-color: #a0cfff;
          }
        }

        .card {
          position: absolute;
          top: 0;
          z-index: 999;
          width: 50%;
          height: 100%;
          max-height: 100%;
          .subjectTips {
            color: #fff;
            flex: 1 1 auto;
            padding: 1vh 1vw;
            text-decoration: none;
            background: linear-gradient(90deg, #2c2c30, rgba(44, 44, 48, 0));
            display: flex;
            flex-direction: column;
            margin-top: 1vh;
            border-radius: 0.2rem;
            transition: background 0.2s;
            .subjectTit {
              color: #fff;
            }
          }
        }
      }

      .d-t-l-b {
        height: 400px;
        margin-top: 30px;
        .fold {
          height: 100%;
        }
      }
    }
    .title {
      width: 70%;
      background: white;
      z-index: 100;
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      margin-left: 15%;
      .title-for {
        font-size: 1.2em;
        display: flex;
        flex-direction: row;
        margin: 0.5em 1em;
        padding-top: 0.5em;
        img {
          margin-top: 0.5em;
          width: 1.3em;
          height: 1.3em;
        }
        .title-right {
          margin-left: 0.7em;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .title_tit {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
          }
        }
      }
      .title-for + .title-for {
        border-top: 1px solid #cfcfcf;
      }
    }
    .qrcode {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 30px;
      margin-top: 30px;
      img {
        width: 150px;
        height: 150px;
      }
      span {
        margin-top: 20px;
      }
    }
  }
  .d-c {
    margin-bottom: 30px;
    .d-c-box {
      .d-c-type {
        margin-top: 15px;
        margin-bottom: 15px;
        .active {
          background-color: #3596db;
          color: #fff;
        }
        li {
          float: left;
          padding: 5px;
          cursor: pointer;
          font-size: 14px;
          border: 1px #000 solid;
          &:nth-child(1),
          &:nth-child(2) {
            border-right: none;
          }
        }
      }
    }
  }
  .d-b {
    margin-top: 30px;
    h3 {
      padding: 0 15px;
      margin-bottom: 15px;
    }
    .detail-l {
      .detail-list {
        margin-bottom: 10px;
        h3 {
          background-color: #ccc;
          padding: 10px 0 10px 10px;
          font-size: 16px;
          font-weight: 600;
          color: #6f6f6f;
        }
        ul {
          background-color: #f7f7f7;
          li {
            padding: 5px 0 5px 10px;
            color: #6f6f6f;
            font-size: 14px;
            cursor: pointer;
            &:hover {
              background-color: #6f6f6f;
              color: #fff;
            }
          }
        }
      }
    }
    .detail-r {
      .menu {
        margin-bottom: 15px;
        h4 {
          float: left;
          font-size: 14px;
          margin-top: 10px;
        }
        .showway {
          float: right;
          span {
            font-size: 12px;
            font-weight: 600;
            vertical-align: text-top;
          }
          img {
            display: inline-block;
            width: 20px;
            height: 20px;
            cursor: pointer;
            margin-left: 5px;
          }
        }
      }
      .res-listelse {
        ul {
          li {
            border-top: 1px #ccc solid;
            padding: 15px;
            margin-bottom: 10px;
            &:last-child {
              border-bottom: 1px #ccc solid;
            }
            dl {
              float: left;
              dt {
                color: #00a8f6;
                font-weight: 500;
                font-size: 16px;
                line-height: 24px;
              }
              dd {
                color: #999999;
                font-size: 12px;
                line-height: 16px;
              }
            }
            .provide {
              float: right;
              span {
                font-size: 12px;
                color: #000;
                border: 1px solid rgba(34, 36, 38, 0.15);
                border-radius: 4px;
                padding: 4px 8px;
              }
            }
          }
        }
      }
    }
  }
  .detail-body {
    display: flex;
    flex-direction: row;
    width: 92vw;
    min-width: 1200px;
    .left {
      padding: 10px;
      background: #fff;
      padding-right: 2%;
      width: 30%;
      margin-right: 2%;
      .conditions {
        .resarch-theme {
          display: flex;
          justify-content: space-between;
          span {
            font-weight: 700;
          }
        }
        .condition {
          margin-top: 20px;
          .el-tag {
            margin: 0 5px 5px 5px;
          }
          .el-input {
            width: 50%;
            margin: 0 5px;
          }
        }
      }
      .border {
        margin: 30px 0;
        border-top: 1px solid #000000;
      }
      .date {
        margin-top: 20px;
        .datePicker {
          margin: 0 10px;
          width: 30%;
        }
      }
      .screening {
        .screening-type {
          .resarch-theme {
            display: flex;
            justify-content: space-between;
            span {
              font-weight: 700;
            }
            .ridio {
              margin-top: -10px;
            }
          }
          .type {
            margin-top: 10px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            .el-tag {
              margin-top: 5px;
              cursor: pointer;
              margin-left: 0.5vw;
            }
          }
        }
        .screening-language {
          margin-top: 10px;
          .language {
            margin-top: 10px;
          }
        }
      }
      .research {
        .resarch-theme {
          display: flex;
          justify-content: space-between;
          span {
            font-weight: 700;
          }
          .ridio {
            margin-top: -10px;
          }
        }
        .simkeyword {
          margin-top: 20px;
          .simkeywords {
            padding: 10px;
            .el-tag {
              cursor: pointer;
              margin: 4px 5px;
              max-width: 90%;
              white-space: nowrap;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              overflow: hidden;
            }
          }
        }
        .more {
          text-align: center;
          font-weight: 800;
        }
        .scholars {
          margin-bottom: 20px;
          .checked {
            margin-top: 10px;
            display: flex;
            width: 18vw;
            align-items: center;

            .el-checkbox__label {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .scholars-bar {
            width: 18vw;
            height: 10px;
            background: #e0e0e0;
            .scholars-bars {
              height: 10px;
              background: #76877d;
            }
          }
        }
      }
    }
    .detail-main {
      background: #fff;
      padding-top: 40px;
      padding-bottom: 60px;
      .main-option {
        padding: 0 40px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
    }
    .research-lable {
      margin: 20px 0;
      font-weight: 700;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/detail/Detail.vue